import createReducer from '../../../../../common/utils/createReducer.js';
import { feedBack } from '../actionTypes/index.js';

const initialState = {
  feedback_widget_data: {},
  feedback_list_data: {},
  isFetchingWidgets: false,
  widgetFetchingError: false,
  isFetchingData: false,
  dataFetchingError: false
};

const reducer = {

  [feedBack.START_FETCHING_FEEDBACK_WIDGETS]: state => {
    return {
      ...state,
      isFetchingWidgets: true,
      dataFetchingError: false
    };
  },

  [feedBack.SUCCESS_FETCHING_FEEDBACK_WIDGETS]: (state, action) => {
    return {
      ...state,
      isFetchingWidgets: false,
      feedback_widget_data: action.payload.feedback_widget_data
    };
  },

  [feedBack.FAILURE_FETCHING_FEEDBACK_WIDGETS]: state => {
    return {
      ...state,
      isFetchingWidgets: false,
      widgetFetchingError: true
    };
  },
  [feedBack.CLEAR_FEEDBACK_WIDGETS]: state => {
    return {
      ...state,
      isFetchingWidgets: false,
      dataFetchingError: true,
      feedback_widget_data: {}
    };
  },
  [feedBack.START_FETCHING_FEEDBACK_DATA]: state => {
    return {
      ...state,
      isFetchingData: true,
      dataFetchingError: false,
    };
  },
  [feedBack.SUCCESS_FETCHING_FEEDBACK_DATA]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      feedback_list_data: action.payload.feedback_list_data
    };
  },
  [feedBack.FAILURE_FETCHING_FEEDBACK_DATA]: state => {
    return {
      ...state,
      isFetchingData: false,
      dataFetchingError: true
    };
  },
  [feedBack.CLEAR_FETCHING_FEEDBACK_DATA]: state => {
    return {
      ...state,
      isFetchingData: false,
      dataFetchingError: true,
      feedback_list_data:{}
    };
  }
};

export default createReducer(initialState, reducer);
